export default "__VITE_ASSET__2681d1ef__"